import type { SortField } from '@/components/widget/content-sort-select';

export type ContentOrderByField = 'timelineAt' | 'createdAt' | 'updatedAt' | 'title' | 'importance';

/**
 * Single source of truth for mapping Explore sort controls to backend orderBy.
 */
export function mapSortFieldToOrderBy(field: SortField): ContentOrderByField {
  switch (field) {
    case 'title':
      return 'title';
    case 'importance':
      return 'importance';
    case 'datetime':
    case 'description':
    case 'createdBy':
    default:
      return 'timelineAt';
  }
}

/**
 * The default Explore ordering: the initial selection, what a cleared saved filter
 * reverts to, and what an unsupported selection is coerced to.
 */
export const DEFAULT_SORT: { field: SortField; direction: 'asc' | 'desc' } = {
  field: 'datetime',
  direction: 'desc',
};

